import { get, set } from "idb-keyval";

export const sendNotificationStatusChecker = async () => {
  let nightMode = false;
  let notificationStatus = true;

  await get("nightMode").then((nightModeIdb) => {
    nightMode =
      nightModeIdb !== undefined && typeof nightModeIdb === "boolean"
        ? nightModeIdb
        : nightMode;
  });

  await get("notificationStatus").then((notificationStatusIdb) => {
    notificationStatus =
      notificationStatusIdb !== undefined &&
      typeof notificationStatusIdb === "boolean"
        ? notificationStatusIdb
        : notificationStatus;
  });

  let hour = new Date().getHours();

  if (notificationStatus && !nightMode) {
    return true;
  } else if (notificationStatus && nightMode) {
    if (hour < 24 && hour > 7) {
      return true;
    }
    return false;
  }

  return false;
};

export const setNotificationDefaultSettings = async () => {
  await get("nightMode").then((nightModeIdb) => {
    nightModeIdb === undefined && set("nightMode", false);
  });

  await get("notificationStatus").then((notificationStatusIdb) => {
    notificationStatusIdb === undefined && set("notificationStatus", true);
  });
};
